import { Box, Icon, ListRow, Text } from '@betterment/samba-react';
import { toTitleCase } from '@betterment/shared-components';

import { ActivityItemStage, ActivityItemStatus } from '../../../../../graphql/schema';

interface StatusRowProps {
  statuses: ActivityItemStatus[];
}
const StatusIcon: React.FC<{ status: ActivityItemStatus }> = ({ status }) => {
  if ([ActivityItemStage.Canceled, ActivityItemStage.Failed].includes(status.stage)) {
    return <Icon name="XCircle" color="icon.critical" size="small" data-testid="status-redx" />;
  }

  const iconName = status.timestamp ? 'CheckmarkCircleFilled' : 'CheckmarkCircle';
  const color = status.timestamp ? 'icon.success' : 'icon.weakest';
  return <Icon name={iconName} color={color} size="small" data-testid={iconName} />;
};

export const StatusSection: React.FC<StatusRowProps> = ({ statuses }) => {
  return (
    <Box css={{ pt: 'space.100', pb: 'space.100' }}>
      {statuses.map(status => {
        const timestamp = status.timestamp && {
          date: new Date(status.timestamp).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          }),
          time: new Date(status.timestamp).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          }),
        };
        return (
          <ListRow key={status.stage} css={{ px: 0, pb: 'space.200', pt: 'space.200' }}>
            <ListRow.LeadingAsset>
              <StatusIcon status={status} />
            </ListRow.LeadingAsset>
            <ListRow.LeadingContent>
              <Text variant="text100">
                {status.stage === ActivityItemStage.Initiated ? 'Pending' : toTitleCase(status.stage)}
              </Text>
              {timestamp && (
                <Text variant="text50" color="text.weak">
                  {timestamp.date} · {timestamp.time}
                </Text>
              )}
            </ListRow.LeadingContent>
            {(status.description || status.message) && (
              <ListRow.BottomContent
                alignment="inset"
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 'space.100',
                }}
              >
                {status.description && (
                  <Text variant="text50" color="text.weak">
                    {status.description}
                  </Text>
                )}
                {status.message && (
                  <Text variant="text50" color="text.weak">
                    {status.message}
                  </Text>
                )}
              </ListRow.BottomContent>
            )}
          </ListRow>
        );
      })}
    </Box>
  );
};
